import { Modal, ModalBody, ModalHeader } from '@vd/ui';
import styles from './KeyboardShortcutsModal.module.css';

const groups: { title: string; items: Array<[string, string]> }[] = [
  {
    title: 'Global',
    items: [
      ['/', 'Focus search'],
      ['⌘K', 'Command palette'],
      ['[', 'Toggle sidebar'],
      ['?', 'Show this dialog'],
    ],
  },
  {
    title: 'Board',
    items: [
      ['J / K', 'Move selection vertically'],
      ['H / L', 'Move between columns'],
      ['Enter', 'Open selected ticket'],
      ['V', 'Cycle view modes'],
      ['T', 'Toggle thumbnails'],
      ['A', 'Assign people'],
      ['E', 'Edit columns'],
    ],
  },
  {
    title: 'Ticket',
    items: [
      ['C', 'Focus comment composer'],
      ['1 to 4', 'Switch DevTools tabs'],
      ['R', 'Toggle redact tool'],
      ['P / H / C / A / T', 'Annotation tools'],
      ['⌘Z / ⌘⇧Z', 'Undo / Redo'],
      ['[ / ]', 'Prev / Next ticket'],
    ],
  },
];

export interface KeyboardShortcutsModalProps {
  open: boolean;
  onClose: () => void;
}

export function KeyboardShortcutsModal({ open, onClose }: KeyboardShortcutsModalProps) {
  return (
    <Modal open={open} onClose={onClose} width={560}>
      <ModalHeader>Keyboard shortcuts</ModalHeader>
      <ModalBody>
        <div className={styles.grid}>
          {groups.map((g) => (
            <div key={g.title} className={styles.group}>
              <div className={styles.groupTitle}>{g.title}</div>
              <div className={styles.rows}>
                {g.items.map(([key, desc]) => (
                  <div key={key} className={styles.row}>
                    <kbd className={styles.kbd}>{key}</kbd>
                    <span>{desc}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
}
